import { useEffect } from 'react'
import { BackHandler } from 'react-native'
import { useToastController } from '@my/ui'
import { useReportGroupPost, useUnreportGroupPost } from './commands'
import { ReportGroupFormData } from './components'
import { ReportGroupPostModal } from './report-group-post-modal'

export interface ReportGroupPostModalContainerProps {
  groupPostId: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const ReportGroupPostModalContainer = (props: ReportGroupPostModalContainerProps) => {
  const toast = useToastController()
  const [reportGroupPost] = useReportGroupPost()
  const [unreportGroupPost] = useUnreportGroupPost()

  useEffect(() => {
    const backAction = () => {
      props.onOpenChange(false);
      return props.open
    }

    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      backAction
    );

    return () => backHandler.remove();
  }, [])

  const handleSubmit = async (data: ReportGroupFormData) => {
    try {
      await reportGroupPost({
        variables: {
          groupPostId: props.groupPostId,
          reason: data.reason,
        },
        onCompleted: () => {
          toast.show('Post reported')
        },
      })
    } catch (error) {
      toast.show('Failed to report post', {
        burntOptions: { preset: 'error' },
      })
      console.error(error)
    }
  }

  const handleUndoReport = async () => {
    try {
      await unreportGroupPost({
        variables: {
          groupPostId: props.groupPostId,
        },
        onCompleted: () => {
          toast.show('Report removed')
        },
      })
    } catch (error) {
      toast.show('Failed to remove report', {
        burntOptions: { preset: 'error' },
      })
      console.error(error)
    }
    props.onOpenChange(false)
  }

  return (
    <ReportGroupPostModal
      open={props.open}
      onOpenChange={props.onOpenChange}
      onSubmit={handleSubmit}
      onUndoReport={handleUndoReport}
    />
  )
}
